module.exports = __webpack_public_path__ + "static/media/update-pin.183c9f3f.svg";